import { Actions } from 'ahooks/lib/useBoolean';
import { RangePickerProps } from 'antd/es/date-picker';
import type { Dayjs } from 'dayjs';

import { IPeriod } from 'types';

export const handleChangeDates = (
  setTrue: Actions['setTrue'],
  value?: IPeriod[],
  onChange?: (value: IPeriod[]) => void,
) => (
  dates: RangePickerProps['value'],
) => {
  const [effectiveFrom, effectiveTo] = dates || [];

  if (effectiveFrom && effectiveTo) {
    setTrue();

    onChange?.([...(value || []), {
      effectiveFrom: effectiveFrom.startOf('day'),
      effectiveTo: effectiveTo.endOf('day'),
    }]);
  }
};

export const handleRemoveDate = (
  index: number,
  value?: IPeriod[],
  onChange?: (value: IPeriod[]) => void,
) => () => {
  // TODO: Get the id for the index

  if (value?.length) {
    const values = value.filter((_, indx) => indx !== index);

    onChange?.(values);
  }
};

export const handleFilterDates = (
  setTrue: Actions['setTrue'],
  setRangePickerValue: React.Dispatch<React.SetStateAction<[Dayjs | null, Dayjs | null]>>,
) => (
  dates: RangePickerProps['value'],
) => {
  const [start, end] = dates || [];
  if (!start || !end) {
    return;
  }
  setRangePickerValue([start.startOf('day'), end.endOf('day')]);

  setTrue();
};
